import {} from "../mod/index.js";
import {} from "../value/index.js";
export function defineBuiltinValue(mod, name, value) {
    mod.builtins.set(name, {
        "@type": "Definition",
        "@kind": "ValueDefinition",
        mod,
        name,
        value,
    });
}
//# sourceMappingURL=defineBuiltinValue.js.map